import { ColumnDef } from "@tanstack/react-table";
import { formatMoneyCents } from "@/core/utils/money";
import { IReferral } from "@/referrals/referral";

const PaidToDateCol = (): ColumnDef<IReferral> => ({
  header: "Paid to date",
  accessorFn: (row) =>
    formatMoneyCents(
      row.payouts.reduce((acc, payout) => acc + Number(payout.amount), 0),
    ) || "$0",
  cell: ({ getValue }) => (
    <span className="tabular-nums">{getValue() as string}</span>
  ),
  size: 125,
  meta: { align: "right" },
});

export default PaidToDateCol;
